const isRumAvailable = () => Boolean(typeof window !== 'undefined' && window?.Ya?.Rum);

/**
 * Отправляет событие об отрисовке основного содержимого.
 *
 * @param time - время относительно жизненного цикла страницы
 */
export function sendHeroElement(time?: number) {
    if (isRumAvailable() && process.env.NODE_ENV === 'production') {
        window?.Ya?.Rum?.sendHeroElement(time);
    }
}
